import { render, staticRenderFns } from "./loadingsafe.vue?vue&type=template&id=3e8e1ca5"
import script from "./loadingsafe.vue?vue&type=script&lang=ts"
export * from "./loadingsafe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VApp,VMain,VOverlay,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e8e1ca5')) {
      api.createRecord('3e8e1ca5', component.options)
    } else {
      api.reload('3e8e1ca5', component.options)
    }
    module.hot.accept("./loadingsafe.vue?vue&type=template&id=3e8e1ca5", function () {
      api.rerender('3e8e1ca5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/loadingsafe.vue"
export default component.exports